import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToolbarAction } from '../../../../features/sequence-diagram-page/types/toolbarAction.types';
import { SafeHtmlPipe } from '../../../pipe/safe-html.pipe';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [CommonModule, SafeHtmlPipe],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent {
  @Input() actions: ToolbarAction[] = [];

  executeAction(action: ToolbarAction): void {
    action.action();
  }
}
